var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Sales - View"}},[_c('div',{staticClass:"vx-input-group flex"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Form for Sales"}},[_c('tab-temp-form')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }